import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import ScrollToTop from "./components/ScrollToTop";

// Hlavní stránky (v navigaci)
import HomePage from "./pages/HomePage";
import ProReditelePage from "./pages/ProReditelePage";
import ProUcastnikyPage from "./pages/ProUcastnikyPage";
import TypySkoleniPage from "./pages/TypySkoleniPage";
import TypySkolPage from "./pages/TypySkolPage";
import ObsahACenaPage from "./pages/ObsahACenaPage";
import ReferencesPage from "./pages/ReferencesPage";
import ContactPage from "./pages/ContactPage";

// Stránky bez navigace (zachováno pro referenci)
import MSPage from "./pages/MSPage";
import ZSPage from "./pages/ZSPage";
import SSPage from "./pages/SSPage";
import VSPage from "./pages/VSPage";
import SkoleniProSkoly from "./pages/SkoleniProSkoly";
import TerminyOnlinePage from "./pages/TerminyOnlinePage";

// Tiskové materiály
import LetakSSPage from "./pages/LetakSSPage";

// Admin
import LoginPage from "./pages/LoginPage";
import AdminPage from "./pages/AdminPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Hlavní navigace */}
          <Route path="/" element={<HomePage />} />
          <Route path="/pro-reditele" element={<ProReditelePage />} />
          <Route path="/pro-ucastniky" element={<ProUcastnikyPage />} />
          <Route path="/typy-skoleni" element={<TypySkoleniPage />} />
          <Route path="/typy-skol" element={<TypySkolPage />} />
          <Route path="/obsah-a-cena" element={<ObsahACenaPage />} />
          <Route path="/reference" element={<ReferencesPage />} />
          <Route path="/kontakt" element={<ContactPage />} />

          {/* Skryté stránky – zachováno pro referenci */}
          <Route path="/ms" element={<MSPage />} />
          <Route path="/zs" element={<ZSPage />} />
          <Route path="/ss" element={<SSPage />} />
          <Route path="/vs" element={<VSPage />} />
          <Route path="/skoleni-pro-skoly" element={<SkoleniProSkoly />} />
          <Route path="/terminy-online" element={<TerminyOnlinePage />} />

          {/* Admin */}
          <Route path="/tym-login" element={<LoginPage />} />
          <Route path="/sprava-poptavek" element={<AdminPage />} />

          {/* Tiskové materiály */}
          <Route path="/letak-ss" element={<LetakSSPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
